import { ReactNode } from 'react';
import clsx from 'clsx';
import DragDropDots from 'assets/icons/drag-drop-dots.svg?react';
import styles from '../DocumentListItem.module.scss';
import { OperationType, ProjectResourceType } from 'services/api/api-client';
import { PermissionGate } from 'helpers/projectPermissions/PermissionGate.tsx';
import { permission } from 'helpers/projectPermissions/types/projectPermission.ts';
import { SelectModeCheckbox } from '../../selectMode/checkbox/SelectModeCheckbox.tsx';
import { useSelectModeContext } from '../../selectMode/useSelectModeContext.tsx';
import { DocumentTreeItemProps } from './types.ts';

type TreeItemHandleProps = {
  itemId: string;
  disableSorting: boolean | undefined;
  handleProps: DocumentTreeItemProps['handleProps'];
  expanded: boolean;
  children?: ReactNode;
};

/** Handles the drag handle and select mode checkbox for a tree item. */
export const TreeItemHandle = ({
  itemId,
  disableSorting,
  handleProps,
  expanded,
  children,
}: TreeItemHandleProps) => {
  const { isSelectMode } = useSelectModeContext();

  return (
    <div
      className={clsx(
        styles.buttonsContainer,
        expanded ? styles.folderExpanded : styles.folderCollapsed,
      )}
    >
      {isSelectMode ? (
        <SelectModeCheckbox id={itemId} />
      ) : (
        <PermissionGate
          permissions={[
            permission(ProjectResourceType.Revision, OperationType.Update),
          ]}
          placeholder={<div className={styles.dragPlaceholder}></div>}
        >
          <a
            className={clsx(
              expanded ? styles.dragHandleExpanded : styles.dragHandleCollapsed,
              disableSorting && styles.dragDropNone,
            )}
            {...handleProps}
          >
            <DragDropDots />
          </a>
        </PermissionGate>
      )}
      {children}
    </div>
  );
};
